import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
// import useLocationGuard from '@/hooks/useLocationGuard';
// import LocationBlocked from './components/LocationBlocked.tsx';


const JoinVideoCall = lazy(() => import('./pages/Video/JoinVideoCall'));
const SendMoneyPage = lazy(() => import('./pages/Money/SendMoney.tsx'));
const Landing = lazy(() => import('./pages/Landing'));
const AppointmentBooking = lazy(() => import('./pages/Appointment/physical.tsx'));
const CreateID = lazy(() => import('./pages/Video/CreateId.tsx'))
const VideoBooking = lazy(() => import('./pages/Appointment/video.tsx'))
const TermsConditions = lazy(() => import('./pages/TermsConditions'))

function AdminPortalRedirect() {
    useEffect(() => {
        const host = window.location.hostname;
        const targetOrigin =
            host === 'web.ehuza.rw' || host.includes('sandbox')
                ? 'https://sandbox.ehuza.rw'
                : 'https://app.ehuza.rw';
        window.location.replace(
            `${targetOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`
        );
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-900" />
        </div>
    );
}

function App() {
    // const { allowed, loading, country } = useLocationGuard();

    // if (loading) {
    //     return (
    //         <div className="min-h-screen flex items-center justify-center bg-gray-50">
    //             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-900" />
    //         </div>
    //     );
    // }
    // if (!allowed) {
    //     return <LocationBlocked country={country} />;
    // }

    return (
        <Routes>
            <Route path="/" element={
                <Suspense fallback={<div>Loading video call...</div>}>
                    <Landing />
                </Suspense>
            } />
            <Route path="/join-video" element={
                <Suspense fallback={<div>Loading video call...</div>}>
                    <JoinVideoCall />
                </Suspense>
            } />
            <Route path="/send-money" element={
                <Suspense fallback={<div>Send Money...</div>}>
                    <SendMoneyPage />
                </Suspense>
            } />
            <Route path="/book-physical-appointment" element={
                <Suspense fallback={<div>Book physical...</div>}>
                    <AppointmentBooking />
                </Suspense>
            } />
            <Route path="/book-video-appointment" element={
                <Suspense fallback={<div>Book video...</div>}>
                    <VideoBooking />
                </Suspense>
            } />
            <Route path="/create" element={
                <Suspense fallback={<div>Send Money...</div>}>
                    <CreateID />
                </Suspense>
            } />
            <Route path="/terms-and-conditions" element={
                <Suspense fallback={<div>Terms & conditions...</div>}>
                    <TermsConditions />
                </Suspense>
            } />
            <Route path="/admin/*" element={<AdminPortalRedirect />} />
            <Route path="/login/*" element={<AdminPortalRedirect />} />
            <Route path="/dashboard/*" element={<AdminPortalRedirect />} />
        </Routes>
    );
}

export default App;
